<main class="page-main">
	<app-page-sub-nav [data]="pageSubNavData" [currVisible]="currVisible"></app-page-sub-nav>
	<section class="page-section" id="overview">
		<h2 id="sectionTitleOverview" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('overview')">
			Overview <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<app-external-resource [componentName]="'Donut Chart'" [includeDescription]="true"
			[otherNames]="true"></app-external-resource>
	</section>
	<section class="page-section" id="example">
		<h2 id="sectionTitleExample" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('example')">
			Live example <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<form class="example-container k-body">
			<div class="page-live-header">
				<select class="page-live-example-select" (change)="changeCurrLive($event)" title="Change Example">
					<option value="default">Default</option>
					<option value="severity">Severity</option>
					<option value="status">Status</option>
				</select>
				<app-theme-switcher></app-theme-switcher>
			</div>
			<div class="page-live-example-content">
				<div *ngIf="selectedDataType == 'default'">
					<kendo-chart [transitions]="true" class="show-default-light">
						<kendo-chart-legend position="right">
							<kendo-chart-legend-item [visual]="legendVisual" cursor="pointer">
							</kendo-chart-legend-item>
						</kendo-chart-legend>
						<kendo-chart-series>
							<kendo-chart-series-item [autoFit]="autofit" type="donut"
								[data]="defaultSeries" categoryField="kind" field="share"
								[colorField]="'colorString'">
								<kendo-chart-series-item-labels position="outsideEnd" color="#fff"
									[content]="labelContent">
								</kendo-chart-series-item-labels>
							</kendo-chart-series-item>
						</kendo-chart-series>
					</kendo-chart>
					<kendo-chart [transitions]="true" class="show-default-dark">
						<kendo-chart-legend position="right">
							<kendo-chart-legend-item [visual]="legendVisual" cursor="pointer">
							</kendo-chart-legend-item>
						</kendo-chart-legend>
						<kendo-chart-series>
							<kendo-chart-series-item [autoFit]="autofit" type="donut"
								[data]="defaultSeries" categoryField="kind" field="share"
								[colorField]="'colorString'">
								<kendo-chart-series-item-labels position="outsideEnd" color="#d0d3d4"
									[content]="labelContent">
								</kendo-chart-series-item-labels>
							</kendo-chart-series-item>
						</kendo-chart-series>
					</kendo-chart>
				</div>
				<div *ngIf="selectedDataType == 'severity'">
					<kendo-chart [transitions]="true" class="show-severity-light">
						<kendo-chart-legend position="right">
							<kendo-chart-legend-item [visual]="legendVisual" cursor="pointer">
							</kendo-chart-legend-item>
						</kendo-chart-legend>
						<kendo-chart-series>
							<kendo-chart-series-item [autoFit]="autofit" type="donut"
								[data]="severitySeries" categoryField="kind" field="share"
								[colorField]="'colorString'">
								<kendo-chart-series-item-labels position="outsideEnd" color="#fff"
									[content]="labelContent">
								</kendo-chart-series-item-labels>
							</kendo-chart-series-item>
						</kendo-chart-series>
					</kendo-chart>
					<kendo-chart [transitions]="true" class="show-severity-dark">
						<kendo-chart-legend position="right">
							<kendo-chart-legend-item [visual]="legendVisual" cursor="pointer">
							</kendo-chart-legend-item>
						</kendo-chart-legend>
						<kendo-chart-series>
							<kendo-chart-series-item [autoFit]="autofit" type="donut"
								[data]="severitySeries" categoryField="kind" field="share"
								[colorField]="'colorString'">
								<kendo-chart-series-item-labels position="outsideEnd" color="#d0d3d4"
									[content]="labelContent">
								</kendo-chart-series-item-labels>
							</kendo-chart-series-item>
						</kendo-chart-series>
					</kendo-chart>
				</div>
				<div *ngIf="selectedDataType == 'status'">
					<kendo-chart [transitions]="true" class="show-status-light">
						<kendo-chart-legend position="right">
							<kendo-chart-legend-item [visual]="legendVisual" cursor="pointer">
							</kendo-chart-legend-item>
						</kendo-chart-legend>
						<kendo-chart-series>
							<kendo-chart-series-item [autoFit]="autofit" type="donut"
								[data]="statusSeries" categoryField="kind" field="share"
								[colorField]="'colorString'">
								<kendo-chart-series-item-labels position="outsideEnd" color="#fff"
									[content]="labelContent">
								</kendo-chart-series-item-labels>
							</kendo-chart-series-item>
						</kendo-chart-series>
					</kendo-chart>
					<kendo-chart [transitions]="true" class="show-status-dark">
						<kendo-chart-legend position="right">
							<kendo-chart-legend-item [visual]="legendVisual" cursor="pointer">
							</kendo-chart-legend-item>
						</kendo-chart-legend>
						<kendo-chart-series>
							<kendo-chart-series-item [autoFit]="autofit" type="donut"
								[data]="statusSeries" categoryField="kind" field="share"
								[colorField]="'colorString'">
								<kendo-chart-series-item-labels position="outsideEnd" color="#d0d3d4"
									[content]="labelContent">
								</kendo-chart-series-item-labels>
							</kendo-chart-series-item>
						</kendo-chart-series>
					</kendo-chart>
				</div>
			</div>
		</form>
	</section>
	<section class="page-section" id="dev">
		<h2 id="sectionTitleDev" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('dev')">
			Developer resources <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="dev-started">
			<h3 id="subSectionTitleDevStarted" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-started')">
				Getting started <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<p>Added to your project's app.module.ts file:</p>
			<code style="margin-top: 10px">import &#123; ChartsModule &#125; from
				'&#64;progress/kendo-angular-charts';</code>
			<code style="margin-top: 10px">import 'hammerjs';</code>
		</section>
		<section class="page-sub-section" id="dev-code">
			<h3 id="subSectionTitleDevCode" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-code')">
				Code examples <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<pre prism class="dark">
				{{ donutChartHTML }}
			</pre>
			<pre prism class="dark">{{ legendVisualTs }}</pre>
		</section>
		<section class="page-sub-section" id="dev-api">
			<h3 id="subSectionTitleDevApi" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('dev-api')">
				API <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<a class="page-kendo-link" target="_blank"
						href="https://www.telerik.com/kendo-angular-ui/components/charts/api/"><svg
							xmlns="http://www.w3.org/2000/svg" width="18px" height="18" viewBox="0 0 49 60.3">
							<path fill="#5ce500"
								d="M11.2 14.9L0 21.3l17.4 10.1v20.1l11.2-6.4c.5-.3.9-1 .9-1.6V24.4L13 14.9c-.5-.3-1.3-.3-1.8 0z">
							</path>
							<path fill="#5ce500"
								d="M12.1 48.4V34.5L0 41.5zM25 .2c-.5-.3-1.3-.3-1.8 0L10.7 7.4l24.1 13.9v27.9L47.3 42c.5-.3.9-1 .9-1.6V13.6L25 .2z">
							</path>
						</svg>Kendo Charts API</a>
				</li>
				<li class="page-section-list-item">
					Refer to the
					<a href="components/donut-chart#behaviors">behaviors section</a>
					to see supported component features.
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="styles">
		<h2 id="sectionTitleStyles" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('styles')">
			Styles <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<ul class="page-section-list">
			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">
						Color (light theme)
					</summary>

					<span class="page-style-list-title">Default</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefault" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Severity</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefaultSeverity" [data]="item"></app-style-row>
					</ul>

					<span class="page-style-list-title">Status</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDefaultStatus" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>

			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">
						Color (dark theme)
					</summary>

					<span class="page-style-list-title">Default</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDark" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Severity</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDarkSeverity" [data]="item"></app-style-row>
					</ul>
					<span class="page-style-list-title">Status</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Color / Token</span>
						</li>
						<app-style-row *ngFor="let item of stylesDarkStatus" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>

			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">Typography</summary>
					<span class="page-style-list-title">All variations</span>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesTypography" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>

			<li class="page-section-list-item">
				<details class="page-style-details">
					<summary class="page-style-summary">Structure</summary>
					<ul class="page-style-list">
						<li class="page-style-list-item page-style-list-item-header">
							<span>Element</span><span>Property</span><span>Value</span>
						</li>
						<app-style-row *ngFor="let item of stylesStructure" [data]="item"></app-style-row>
					</ul>
				</details>
			</li>
		</ul>
	</section>
	<section class="page-section" id="behaviors">
		<h2 id="sectionTitleBehaviors" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('behaviors')">
			Behaviors <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="behaviors-legend">
			<h3 id="subSectionTitleBehaviorsLegend" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('behaviors-legend')">
				Legend visibility
				 <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>

			<ul class="page-section-list">
				<li class="page-section-list-item">
					The chart's legend displays the data. Selecting the legend
					items toggles the visibility of the data. When the legend
					item is selected, the data is hidden from the chart and the
					text appears greyed out on the legend.
				</li>
				<li class="page-section-list-item">
					All data should be displayed by default. Users can then
					decide what they want to hide or show.
				</li>
				<li class="page-section-list-item">
					Don't hide the legend completely, unless only one type of
					data is displayed.
				</li>
				<li class="page-section-list-item">
					<a class="page-kendo-link" target="_blank"
						href="https://www.telerik.com/kendo-angular-ui/components/charts/elements/legend/"><svg
							xmlns="http://www.w3.org/2000/svg" width="18px" height="18" viewBox="0 0 49 60.3">
							<path fill="#5ce500"
								d="M11.2 14.9L0 21.3l17.4 10.1v20.1l11.2-6.4c.5-.3.9-1 .9-1.6V24.4L13 14.9c-.5-.3-1.3-.3-1.8 0z">
							</path>
							<path fill="#5ce500"
								d="M12.1 48.4V34.5L0 41.5zM25 .2c-.5-.3-1.3-.3-1.8 0L10.7 7.4l24.1 13.9v27.9L47.3 42c.5-.3.9-1 .9-1.6V13.6L25 .2z">
							</path>
						</svg>Kendo Legend Guide</a>
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="variations">
		<h2 id="sectionTitleVariations" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('variations')">
			Variations <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="variations-default">
			<h3 id="sectionTitleVariationsDefault" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('variations-default')">
				Default <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Uses default chart colors. Default donut charts are for data
					that doesn't need severity or status treatment.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="variations-severity">
			<h3 id="subSectionTitleStyles" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('variations-severity')">
				Severity <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Charts that use the colors and labeling, as outlined in the
					severity guidelines, to
					display severity data to the user.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="variations-status">
			<h3 id="subSectionTitleStyles" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('variations-status')">
				Status <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Provide users with the statuses from a collection of items.
					The statuses are Success, Warning, Error, and Informational.
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="usage">
		<h2 id="sectionTitleUsage" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('usage')">
			Usage guidelines <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<section class="page-sub-section" id="usage-general-use">
			<h3 id="subSectionTitleUsageGeneralUse" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-general-use')">
				General <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					<span class="page-section-do-list-title">Do use donut charts:</span>
					<ul class="page-section-do-list">
						<li class="page-section-list-item">
							When you show relative proportions and percentages
							of a whole dataset.
						</li>
						<li class="page-section-list-item">
							With small datasets&#8212;no more than 6 categories.
						</li>
						<li class="page-section-list-item">
							When comparing the effect of one factor on different
							categories.
						</li>
					</ul>
				</li>
			</ul>
			<ul class="page-section-list">
				<li class="page-section-list-item" style="margin-top: 5px">
					<span class="page-section-do-list-title">Don't use donut charts:</span>
					<ul class="page-section-do-list">
						<li class="page-section-list-item">
							If you have a big dataset.
						</li>
						<li class="page-section-list-item">
							If you want to make a precise or absolute comparison
							between values.
						</li>
					</ul>
				</li>
			</ul>
			<ul class="page-section-list">
				<li class="page-section-list-item" style="margin-top: 5px">
					<span class="page-section-do-list-title">Pie chart or donut chart?</span>
					<ul class="page-section-do-list">
						<li class="page-section-list-item">
							Either or. <a href="components/pie-chart">Pie charts</a> and donut charts display the
							same types of data. Choose one or the other and
							stick to it across a product for consistency's sake.
						</li>
						<li class="page-section-list-item">
							The only real difference is that donut charts can
							convey additional data points in the “hole.” Don't
							do this, as it makes the chart more difficult to
							read.
						</li>
					</ul>
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="usage-content">
			<h3 id="subSectionTitleUsageContent" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-content')">
				Content <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<b>Labels</b>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Donut chart labels should be short, while still clearly
					describing the data. Use title case. There are two alignment
					options for labels, circular and column. Circular is the
					default, so use circular for consistency's sake.
				</li>
			</ul>
		</section>
		<section class="page-sub-section" id="usage-placement">
			<h3 id="subSectionTitleUsagePlacement" class="page-sub-section-title" title="Copy Link to Clipboard"
				(click)="copyToClipboard('usage-placement')">
				Placement <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
			</h3>
			<ul class="page-section-list">
				<li class="page-section-list-item">
					Legends can be placed above, below, or on either side of a
					chart. Choose the best placement depending on the amount of
					space and text alignment, but make sure the placement is
					consistent across a product. This helps users anticipate
					where to look for a legend when interpreting data.
				</li>
			</ul>
		</section>
	</section>
	<section class="page-section" id="related">
		<h2 id="sectionTitleRelated" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('related')">
			Related
			 <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<span class="page-related-list-title">Referenced in this section:</span>
		<ul class="page-section-list page-related-list">
			<li class="page-related-list-item">
				<a href="components/bar-chart">Bar chart component</a>
			</li>
			<li class="page-related-list-item">
                <a href="guidelines/colors">Colors guidelines</a>
            </li>
			<li class="page-related-list-item">
				<a href="guidelines/data-visualization">Data visualization guidelines</a>
			</li>
			<li class="page-related-list-item">
				<a href="components/pie-chart">Pie chart component</a>
			</li>
			<li class="page-related-list-item">
				<a href="components/line-chart">Line Chart component</a>
			</li>
			<li class="page-related-list-item">
				<a href="guidelines/severity">Severity guidelines</a>
			</li>
			<li class="page-related-list-item">
				<a href="guidelines/typography">Typography guidelines</a>
			</li>
		</ul>
	</section>

	<section class="page-section" id="history">
		<h2 id="sectionTitleHistory" class="page-section-title" title="Copy Link to Clipboard"
			(click)="copyToClipboard('history')">
			Revision history <kendo-svg-icon [icon]="linkIcon"></kendo-svg-icon>
		</h2>
		<ul class="page-history-list">
			<li class="page-history-list-item" *ngFor="
						let subItem of changelogService.getChangelogBySection(
							'Donut Chart Component'
						)
					">
				<span class="page-history-list-item-title">{{
					changelogService.formatDate(subItem.changeDate)
					}}</span>
				<a class="page-history-list-item-link" target="_blank" *ngIf="subItem.workId != ''" [attr.href]="
							'https://beyondtrust.atlassian.net/jira/software/c/projects/SDS/issues/' +
							subItem.workId
						">[{{ subItem.workId }}]</a>{{ subItem.changeName }}
			</li>
		</ul>
	</section>
</main>